import { render } from "./CreateGuiTheme.vue?vue&type=template&id=25cbbda5&scoped=true"
import script from "./CreateGuiTheme.vue?vue&type=script&lang=js"
export * from "./CreateGuiTheme.vue?vue&type=script&lang=js"

import "./CreateGuiTheme.vue?vue&type=style&index=0&id=25cbbda5&lang=scss&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cbbda5"]])

export default __exports__